/** Metrics period - rolling days or calendar month (Shopify Analytics-style). */

export type StatsPeriod =
  | { kind: "days"; days: number }
  | { kind: "month"; month: string };

export function statsPeriodKey(p: StatsPeriod): string {
  return p.kind === "month" ? `m:${p.month}` : `d:${p.days}`;
}

export function monthLabel(ym: string): string {
  const [y, m] = ym.split("-").map(Number);
  if (!y || !m) return ym;
  return new Date(Date.UTC(y, m - 1, 1)).toLocaleString("en-US", {
    month: "long",
    year: "numeric",
    timeZone: "UTC",
  });
}

/** Calendar months whose start falls within the plan lookback window. */
export function availableMonths(statsMax: number): string[] {
  const out: string[] = [];
  const now = new Date();
  const lookbackMs = Math.max(1, statsMax) * 86400000;
  for (let i = 0; i < 24; i++) {
    const d = new Date(
      Date.UTC(now.getUTCFullYear(), now.getUTCMonth() - i, 1),
    );
    if (i > 0 && now.getTime() - d.getTime() > lookbackMs) break;
    out.push(
      `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, "0")}`,
    );
  }
  return out;
}

export function rollingDayOptions(statsMax: number): number[] {
  return [7, 30, 90].filter((d) => d <= statsMax);
}
